// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-management-usersAndRoles-users-single-UserForm-module__formBox--VcvP3 {
  max-width: 600px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
/*# sourceMappingURL=UserForm.module.css.map */`, "",{"version":3,"sources":["webpack://./UserForm.module.less","webpack://./src/pages/management/usersAndRoles/users/single/UserForm.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ACCF;AACA,8CAA8C","sourcesContent":[".formBox {\n  max-width: 600px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n",".formBox {\n  max-width: 600px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n/*# sourceMappingURL=UserForm.module.css.map */"],"sourceRoot":""}]);
// Exports
export var formBox = `src-pages-management-usersAndRoles-users-single-UserForm-module__formBox--VcvP3`;
export default ___CSS_LOADER_EXPORT___;
